export default __webpack_public_path__ + "static/media/complementary--pedestrians-right--g1.01475b36.png";